// @flow

import React from 'react';
import type { Node } from 'react';
import { reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';
import Form from './form.styled';

type OwnProps = {
  children: Node,
  onSubmit: Function,
  form: string,
};

type Props = OwnProps & FormProps;

const ReduxFormForm = ({
  children,
  onSubmit,
  handleSubmit,
  form,
}: Props) => (
  <Form
    form={form}
    onSubmit={handleSubmit(onSubmit)}
  >
    {children}
  </Form>
);

export default reduxForm()(ReduxFormForm);
